import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Bookmarks - INGAZ Print";

function Bookmarks() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Custom Bookmarks" images={[asset('assets/bookmark-1.png'), asset('assets/bookmark-2.png'), asset('assets/bookmark-3.png'), asset('assets/image18.webp')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Bookmarks" data-ar="الفواصل">Bookmarks</h1>
                <p className="product-description" data-en="Custom printed bookmarks for promotional use, libraries, and bookstores." data-ar="فواصل مطبوعة مخصصة للاستخدام الترويجي والمكتبات ومحلات الكتب.">Custom printed bookmarks for
                  promotional use, libraries, and bookstores.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Durable" data-ar="متين">Durable</div>
                      <div className="feature-detail" data-en="Long lasting" data-ar="طويل الأمد">Long lasting</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Cost-effective promotional item" data-ar="عنصر ترويجي منخفض التكلفة">
                      Cost-effective promotional item</li>
                    <li data-en="Long-lasting brand exposure with every read" data-ar="عرض طويل الأمد للعلامة التجارية مع كل قراءة">
                      Long-lasting brand exposure with every read</li>
                    <li data-en="Premium cardstock and finishing options" data-ar="ورق مقوى فاخر وخيارات تشطيب">
                      Premium cardstock and finishing options</li>
                    <li data-en="Perfect for book launches and literary events" data-ar="مثالي لإطلاق الكتب والفعاليات الأدبية">
                      Perfect for book launches and literary events</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Bookstores" data-ar="مكتبات">Bookstores</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Libraries" data-ar="المكتبات العامة">Libraries</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Book Launches" data-ar="إطلاق الكتب">Book Launches</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Promo Gifts" data-ar="هدايا ترويجية">Promo Gifts</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Bookmarks" data-ar="قم بتكوين الفواصل">Configure Your Bookmarks</h2>
                
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="50x200mm" data-dims="5x20 cm"><span>5x20 cm</span><br /><span>50x200 mm</span></div>
                    <div className="size-option" data-size="60x210mm" data-dims="6x21 cm"><span>6x21 cm</span><br /><span>60x210 mm</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="Custom" data-ar="مخصص">Custom</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                
                {/* Shape */}
                <div className="config-group">
                  <label data-en="Shape" data-ar="الشكل">Shape</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="Rectangle" defaultChecked />
                      <span data-en="Rectangle" data-ar="مستطيل">Rectangle</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="Rounded corners" />
                      <span data-en="Rounded corners" data-ar="زوايا دائرية">Rounded corners</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="Custom die-cut shape" />
                      <span data-en="Custom die-cut shape" data-ar="شكل مقصوص مخصص">Custom die-cut shape</span>
                    </label>
                  </div>
                </div>

                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType" onChange={(e) => {
                      const lamInputs = document.querySelectorAll('input[name="lamination"]');
                      if(e.target.value !== 'couche-350') {
                        lamInputs.forEach(i => { i.disabled = true; if(i.value === 'none') i.checked = true; });
                      } else {
                        lamInputs.forEach(i => i.disabled = false);
                      }
                    }}>
                      <option value="couche-350" data-en="Couche 350 gsm" data-ar="كوشيه 350 جم">Couche 350 gsm</option>
                      <option value="fabriano-230" data-en="Fabriano 230 gsm" data-ar="فابريانو 230 جم">Fabriano 230 gsm</option>
                      <option value="crystal-white-230" data-en="Crystal White 230 gsm" data-ar="كريستال أبيض 230 جم">Crystal White 230 gsm</option>
                      <option value="crystal-silver-230" data-en="Crystal Silver 230 gsm" data-ar="كريستال فضي 230 جم">Crystal Silver 230 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>

                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>

                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printed Sides" data-ar="الجوانب المطبوعة">Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="Single Side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Single Side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double Sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double Sides</span>
                    </div>
                  </div>
                </div>

                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '8px'}} data-en="(Only available for Couche paper)" data-ar="(متاح فقط لورق كوشيه)">(Only available for Couche paper)</p>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt-both" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Matt Cellophane [Both sides]" data-ar="سيلوفان مطفي [كلا الجانبين]">Matt Cellophane [Both sides]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss-both" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Gloss Cellophane [Both sides]" data-ar="سيلوفان لامع [كلا الجانبين]">Gloss Cellophane [Both sides]</span>
                    </label>
                  </div>
                </div>

                {/* Special Finishing */}
                <div className="config-group">
                  <label data-en="Special Finishing" data-ar="تشطيبات خاصة">Special Finishing</label>
                  <div className="finishing-options">
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Spot UV" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Spot UV" data-ar="سبوت يو في">Spot UV</span>
                    </label>
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Embossing" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Embossing" data-ar="بصمة بارزة">Embossing</span>
                    </label>
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Foil Stamping (Silver)" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Foil Stamping (Silver)" data-ar="بصمة فويل (فضي)">Foil Stamping (Silver)</span>
                    </label>
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Foil Stamping (Gold)" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Foil Stamping (Gold)" data-ar="بصمة فويل (ذهبي)">Foil Stamping (Gold)</span>
                    </label>
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Foil Stamping (Other)" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Foil Stamping (Other)" data-ar="بصمة فويل (أخرى)">Foil Stamping (Other)</span>
                    </label>
                    <label className="checkbox-option">
                      <input type="checkbox" name="specialFinishing" defaultValue="Hole punch with tassel / ribbon" onChange={(e) => {
                          const ta = document.getElementById('finishingNotes');
                          ta.style.display = document.querySelectorAll('input[name="specialFinishing"]:checked').length > 0 ? 'block' : 'none';
                        }} />
                      <span data-en="Hole punch with tassel / ribbon" data-ar="ثقب مع شريطة">Hole punch with tassel / ribbon</span>
                    </label>
                  </div>
                  <textarea id="finishingNotes" placeholder="Describe finishing areas and if it's on 1 or 2 sides" data-placeholder-en="Describe finishing areas and if it's on 1 or 2 sides" data-placeholder-ar="اوصف مناطق التشطيب وما إذا كانت على جانب واحد أو جانبين" rows={3} style={{display: 'none', marginTop: '10px'}}></textarea>
                </div>
                
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload artwork" data-ar="رفع العمل الفني">Upload artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>

                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">50x200 mm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Shape:" data-ar="الشكل:">Shape:</span>
                    <span className="summary-value" id="summaryShape">Rectangle</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Sides:" data-ar="جوانب الطباعة:">Sides:</span>
                    <span className="summary-value" id="summarySides">Single Side</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design
                    review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image12.webp')} alt="Notebooks" />
                  </div>
                  <h3 data-en="Notebooks" data-ar="المفكرات">Notebooks</h3>
                  <p data-en="Custom notebooks" data-ar="مفكرات مخصصة">Custom notebooks</p>
                  <a href="/notebooks" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Bookmarks;
